import { render, staticRenderFns } from "./ShiftTableWrapper.vue?vue&type=template&id=0d58fe3c&scoped=true&"
import script from "./ShiftTableWrapper.vue?vue&type=script&lang=js&"
export * from "./ShiftTableWrapper.vue?vue&type=script&lang=js&"
import style0 from "./ShiftTableWrapper.vue?vue&type=style&index=0&id=0d58fe3c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d58fe3c",
  null
  
)

export default component.exports